var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var formGroup = require('../../components/formGroup');
var ToggleSwitch = require('../../components/toggleSwitch');
var choices = require('../../libs/choices');
var renderWidthSelector = require('../../components/widthSelector');
var elementPresentation = require('../../dashboards/models/element');
var renderSection = elementPresentation.renderSection;
var dataset = Object.assign(require('../../../../../models/data/dataset'), Model);
var equipmentClassTree  = require('../../equipment/models/equipment');
var formDataFields = require('../../libs/formDataFields');
var IMAGE_FORM_SKIP_FIELDS = ['@rid', 'srcPath', 'path'];

dataset.initForm();
dataset.hideTypeSelect = false;

function viewOption(vnode, optionName) {
  return !!(vnode && vnode.attrs && vnode.attrs[optionName]);
}

function renderNameField() {
  return m(formGroup, [
    m('name', {for:'dashboard-name-input'}, 'Name'),
    m('input.form-control', {
      id:'dashboard-name-input',
      type:'text',
      oninput: function(ev){dataset.form.name(ev.target.value)},
      value: dataset.form.name(),
      readonly: dataset.form.name() == 'Default' ? true : false,
    })
  ]);
}

function renderUrlField() {
  if (dataset.form.type() === 'spacer' || dataset.form.type() === 'text') {
    if (!(dataset.form['@rid'] && dataset.form['@rid']())) {
      dataset.form.url(null);
    }
    return null;
  }

  return m(formGroup, [
    m('name', {for:'dashboard-name-input'}, 'URL'),
    m('input.form-control', {
      id:'dashboard-url-input',
      type:'text',
      oninput: function(ev){dataset.form.url(ev.target.value)},
      value: dataset.form.url(),
    })
  ]);
}

function showVisibilityOptions() {
  return dataset.form.type() !== 'spacer' && dataset.form.type() !== 'img' && dataset.form.type() !== 'graphic';
}

function parentClass() {
  return dataset.form.parent() && dataset.form.parent()['@class'];
}

function parentSupportsPermissionClasses() {
  var cls = parentClass();
  return !!cls && cls !== 'Dashboard' && cls !== 'Element';
}

function parentSupportsEquipmentDataOptions() {
  var cls = parentClass();
  return parentSupportsPermissionClasses() &&
    cls !== 'Site' &&
    cls !== 'Building' &&
    cls !== 'Level' &&
    cls !== 'Floor' &&
    cls !== 'Room';
}

function renderTypeField() {
  if (dataset.hideTypeSelect || (dataset.form['@rid'] && dataset.form['@rid']())) {
    return null;
  }
  if (dataset.form.parent() && dataset.form.parent()['@class'] && dataset.form.parent()['@class'] != 'Element') {
    return m(formGroup, [
      m('name', 'Type'),
      m('select.form-control', {
        onchange: function(ev){dataset.form.type(ev.target.value)},
        value: dataset.form.type(),
        disabled: dataset.form['@rid'] && dataset.form['@rid']() ? true : false
      }, [
        m("option", {value:"list"}, "List"),
        m("option", {value:"gauge"}, "Gauge"),
        m("option", {value:"chart"}, "Chart"),
        m("option", {value:"spacer"}, "Spacer"),
        m("option", {value:"img"}, "Image"),
        m("option", {value:"text"}, "Text"),
      ]),
    ]);
  }
  return null;
}

function renderWidthField() {
  if (dataset.form.type() === 'spacer') {
    dataset.form.width(4);
    return null;
  }
  if (dataset.form.parent() && dataset.form.parent()['@class'] && dataset.form.parent()['@class'] != 'Element') {
    return m(formGroup, [
      m("name", {for:"dataset-type-input"}, "Width"),
      renderWidthSelector({
        selectedWidth: dataset.form.width,
        onselect: function (width) {
          dataset.form.width(width);
        }
      })
    ])
  }
  return null;
}

dataset.modalTitle = function (defaultTitle, record) {
  if (!record || !record.datasetRepresentation) {
    return defaultTitle;
  }
  return elementPresentation.modalTitle(defaultTitle, record);
};

dataset.view = function (vnode) {
  const mainEquipmentClasses = equipmentClassTree.equipmentClassTree.categories.map((category) => {
    return {
      name: category.name,
      value: category.name,
    }
  });
  dataset.save = function() {
    const formData = new FormData();
    const { ['@rid']: rid, src } = dataset.form;
    
    const hasValidSrc = src && src() !== 'null' && src() !== null && src() !== '' && src() !== undefined && src() !== 'undefined';
    if (dataset.form.parent() && dataset.form.parent()['@rid'] ) {
      dataset.form.parent(dataset.form.parent()['@rid']);
    }

    if (rid && rid()) {
      if (hasValidSrc) {
        formDataFields.appendFormFields(formData, dataset.form, {
          skipFields: IMAGE_FORM_SKIP_FIELDS
        });
        return loaders.requestWithLoader({
          loader: 'submit',
          url: `/api/v1/dataset/${rid().slice(1)}/image`,
          method: 'PUT',
          body: formData
        });
      } else {
        return Model.save.call(dataset);
      }
    } else {
      if (hasValidSrc) {
        formDataFields.appendFormFields(formData, dataset.form, {
          skipFields: IMAGE_FORM_SKIP_FIELDS
        });
        return loaders.requestWithLoader({
          loader: 'submit',
          url: `/api/v1/${dataset.url}`,
          method: 'POST',
          body: formData
        });
      } else {
        return Model.save.call(dataset);
      }
    }
  };

  if (!dataset.form.type()) {
    dataset.form.type('list')
  }

  if (!dataset.form.width()) {
    dataset.form.width(1)
  }
  var datasetType = dataset.form.type && dataset.form.type();
  var viewOptionFields = [
    renderUrlField(),
    (function () {
      if (datasetType !== 'chart' && datasetType !== 'smallchart') {
        return null;
      }
      return m(formGroup, [
        m("name", {for:"dataset-name-input"}, "Span"),
        m("input.form-control", {
          type:"number",
          autocomplete: 'off',
          oninput: function(ev) { dataset.form.chartSpan(ev.target.value) },
          value: dataset.form.chartSpan(),
        }),
        m("name", {for:"dataset-type-input"}, "Chart Resample"),
        m("select.form-control", {
          onchange: function(ev) { dataset.form.chartResample(ev.target.value) },
          value: dataset.form.chartResample(),
        }, [
          m("option", {value:"hour"}, "Hour"),
          m("option", {value:"hours"}, "Hours"),
          m("option", {value:"days"}, "Days"),
          m("option", {value:"minutes"}, "Minutes")
        ]),
        m(formGroup, [
          m('name', {for:'dashboard-yMax-input'}, 'Y Maximum'),
          m('input.form-control', {
            id:'dashboard-yMax-input',
            type:'number',
            oninput: function(ev) { dataset.form.yMax(ev.target.value) },
            value: dataset.form.yMax(),
          })
        ]),
        m(formGroup, [
          m('name', {for:'dashboard-yMin-input'}, 'Y Minimum'),
          m('input.form-control', {
            id:'dashboard-yMin-input',
            type:'number',
            oninput: function(ev) { dataset.form.yMin(ev.target.value) },
            value: dataset.form.yMin(),
          })
        ])
      ]);
    })(),
    (function () {
      if (datasetType !== 'spacer') {
        return null;
      }
      return m(formGroup, [
        m("name", {for:"dataset-type-input"}, "Display As "),
        m("select.form-control", {
          onchange: function(ev) { dataset.form.dividerType(ev.target.value) },
          value: dataset.form.dividerType(),
        }, [
          m("option", {value:"blank"}, "Hidden"),
          m("option", {value:"line"}, "Line")
        ]),
      ]);
    })(),
    (function () {
      if (datasetType !== 'text') {
        return null;
      }
      if (!dataset.form.height()) {
        dataset.form.height(2);
      }
      return m(formGroup, [
        m("label", "Height"),
        m("select.form-control", {
          onchange: function(ev) { dataset.form.height(ev.target.value) },
          value: dataset.form.height(),
        }, [
          m("option", {value:1}, "None"),
          m("option", {value:2}, "Single"),
          m("option", {value:3}, "Double"),
          m("option", {value:4}, "Full")
        ]),
      ]);
    })(),
    viewOption(vnode, 'hideWidthSelect') ? null : renderWidthField()
  ];
  var leadingFields = [
    dataset.errorView(),
    renderTypeField(),
    viewOption(vnode, 'hideNameInput') ? null : renderNameField()
  ];

  if (viewOption(vnode, 'deferTypeSpecificFields')) {
    return m('form', {role:'form'}, leadingFields);
  }

  return  m('form', {role:'form'}, leadingFields.concat([
    (function () {
      if (datasetType === 'img' || datasetType === 'graphic') {
        return m(formGroup, [
          m("label", {for:"dataset-src-input"}, "Src"),
          m('input.form-control', {
            type: 'file',
            accept: 'image/*',
            style: {background: 'transparent', border: 'none'},
            onchange: function (e) {
                if (e.target.files && e.target.files[0]) {
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        var imagePreview = document.getElementById('image-preview');
                        if (imagePreview) {
                            imagePreview.src = event.target.result;
                            imagePreview.style.display = 'block'; // Make the image visible
                        }
                        m.redraw(); // Force Mithril to update the DOM
                    }
                    reader.readAsDataURL(e.target.files[0]);
                    dataset.form.src(e.target.files[0]);
                }
            }
          }),
          m('img', {
              id: 'image-preview',
              src: dataset.form['@rid'] && dataset.form['@rid']() ?
                  `/api/v1/dataset/${dataset.form['@rid']().slice(1)}/image` : '',
              alt: 'Image Preview',
              style: { maxWidth: '200px', maxHeight: '200px', display: dataset.form['@rid'] && dataset.form['@rid']() ? 'block' : 'none' } // Hide initially if no image
          })
        ]);
      }
    })(),
    (function () {
      if (datasetType === 'spacer') {
        return m(formGroup, [
          m("name", {for:"dataset-name-input"}, "Label"),
          m("input.form-control", {
            type:"text",
            autocomplete: 'off',
            oninput: function(ev) { dataset.form.label(ev.target.value) },
            value: dataset.form.label(),
          }),
        ]);
      }
    })(),
    (function () {
      if (datasetType === 'text') {
        return m(formGroup, [
          m("name", {for:"dataset-name-input"}, "Markdown Text"),
          m('textarea', {
            resize: 'none',
            id:'comment',
            rows:'5',
            cols:'40',
            'box-sizing': 'border-box',
            placeholder:"Add your markdown text here...",
            oninput: function(ev) { dataset.form.markdownText(ev.target.value) },
            value: dataset.form.markdownText(),
          })
        ]);
      }
    })(),
    (() => {
      if (!parentSupportsPermissionClasses()) return null;
      return [
        parentSupportsEquipmentDataOptions() ? [
          m(formGroup, [
            m('name', 'Help text'),
            m('textarea', {
              resize: 'none',
              id:'comment',
              rows:'5',
              cols:'40',
              'box-sizing': 'border-box',
              placeholder:"Add your help markdown text here...",
              oninput: function(ev) { dataset.form.helpText(ev.target.value) },
              value: dataset.form.helpText(),
            })
          ]),
          showVisibilityOptions() ? renderSection('Equipment Data Options', [
            m('div.mr1.w-100.mb2.flex.justify-between', [
              m('label',`Show In Summary`),
              m(ToggleSwitch, {
                id: 'check_showInSummary',
                checked: dataset.form.showInSummary() == 'true',
                ariaLabel: 'Show in summary',
                onchange: function (ev) {
                  dataset.form.showInSummary(ev.target.checked ? 'true' : 'false');
                }
              })
            ]),
            m('div.mr1.w-100.mb2.flex.justify-between', [
              m('label',`Hide In Diagram`),
              m(ToggleSwitch, {
                id: 'check_hideInDiagram',
                checked: dataset.form.hideInDiagram() == 'true',
                ariaLabel: 'Hide in diagram',
                onchange: function (ev) {
                  dataset.form.hideInDiagram(ev.target.checked ? 'true' : 'false');
                }
              })
            ]),
            m('div.mr1.w-100.mb2.flex.justify-between', [
              m('label',`External Diagrams`),
              m(ToggleSwitch, {
                id: 'check_hideInParentDiagram',
                checked: dataset.form.hideInParentDiagram() == 'true',
                ariaLabel: 'External diagrams',
                onchange: function (ev) {
                  dataset.form.hideInParentDiagram(ev.target.checked ? 'true' : 'false');
                }
              })
            ]),
            m('div.mr1.w-100.mb2.flex.justify-between', [
              m('label',`Hide In Equipment Detail`),
              m(ToggleSwitch, {
                id: 'check_hideInEquipmentDetail',
                checked: dataset.form.hideInEquipmentDetail() == 'true',
                ariaLabel: 'Hide in equipment detail',
                onchange: function (ev) {
                  dataset.form.hideInEquipmentDetail(ev.target.checked ? 'true' : 'false');
                }
              })
            ]),
            m('div.mr1.w-100.mb2.flex.justify-between', [
              m('label',`Hide In Parent Equipment Detail`),
              m(ToggleSwitch, {
                id: 'check_hideInParentEquipmentDetail',
                checked: dataset.form.hideInParentEquipmentDetail() == 'true',
                ariaLabel: 'Hide in parent equipment detail',
                onchange: function (ev) {
                  dataset.form.hideInParentEquipmentDetail(ev.target.checked ? 'true' : 'false');
                }
              })
            ]),
            m('div.mr1.w-100.mb2.flex.justify-between', [
              m('label',`Hide on maps`),
              m(ToggleSwitch, {
                id: 'check_hideOnMap',
                checked: dataset.form.hideOnMap() == 'true',
                ariaLabel: 'Hide on map',
                onchange: function (ev) {
                  dataset.form.hideOnMap(ev.target.checked ? 'true' : 'false');
                }
              })
            ])
          ]) : null
        ] : null,
        m(formGroup, [
          m('name', 'Permission Classes'),
          m(choices, {
            data: mainEquipmentClasses,
            value: dataset.form.permissionClasses,
          })
        ])
      ];
    })(),
    renderSection('View Options', viewOptionFields)
  ]));
};

dataset.renderNameField = renderNameField;
dataset.renderWidthField = renderWidthField;

module.exports = dataset;
